var render = function (_h,_vm) {var _c=_vm._c;return _c('nav',{staticClass:"mobile-bar md:hidden fixed left-0 bottom-0 h-14 flex w-screen bg-white shadow z-50"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }